<template>
  <div style="background-color: #F5F5F5;">
    <createCategory
      ref="categoryForm"
      :visible="visible"
      v-if="visible"
      @cancel="hideForm"
      @create="hideForm"
    />
    <a-page-header
      :ghost="false"
      title="分类"
      sub-title="事件分类"
      :backIcon="false"
    >
      <template slot="extra">
        <a-button type="dashed" icon="plus" @click="showForm"
          >添加分类</a-button
        >
      </template>
      <template slot="footer">
        <a-tabs default-active-key="active" @change="changeTab">
          <a-tab-pane key="active" tab="使用" />
          <a-tab-pane key="archive" tab="归档" />
        </a-tabs>
      </template>
    </a-page-header>
  </div>
</template>
<style></style>

<script>
// import createCategoryCard from "../../components/createCategoryCard"
import createCategory from "./CategoryForm";
import { mapActions } from "vuex";

export default {
  components: { createCategory },

  data() {
    return {
      visible: false
    };
  },
  methods: {
    changeTab(activeKey) {
      this.$emit("change", activeKey);
    },
    showForm(event) {
      if (event.screenX + event.screenY + event.clientX + event.clientY === 0)
        return; //莫名奇妙的会自动触发click，导致表单重新出现,通过点击位置判断是否为自动触发的
      this.visible = true;
    },
    hideForm() {
      this.visible = false;
    },
    ...mapActions(["createCategory"])
  }
};
</script>
